/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SVG from "react-inlinesvg";
import Button from "../../Components/Button/Button";
import CustomModal from "../../Components/Modals/CustomModal";
import { Col, Nav, Row } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import AddPatientCSV from "./Components/AddPatientCSV";
import { useAppDispatch } from "../../Store/Hooks";
import { orderActions } from "../../Store/Order/reducer";
// import PatientInfoForm from "./Components/PatientInfoForm";

const AddPatientLeads = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isBack, setIsBack] = useState<boolean>(false);
  const [isFileSelected, setIsFileSelected] = useState<boolean>(false);

  useEffect(() => {
    dispatch(orderActions.resetOrderProcessingStates());
  }, []);

  const importComplete = () => {
    navigate("/order");
  }

  const backRedirect = () => {
    document.body.classList.remove('backdroperbackbtn');
    navigate("/dashboard");
  }

  const backButtonClick = () => {
    document.body.classList.add('backdroperbackbtn');
    setIsBack(true);
  }

  const cancelClick = () => {
    document.body.classList.remove('backdroperbackbtn');
    setIsBack(false);
  }

  const ConfirmBox = () => {
    return (
      <>
        <p className="text-center fs-20">Are you sure to quit the Add Patient process?</p>
        <div className="text-center d-flex mb-3">
          <Button
            customClass="mt-3 mx-3"
            label="Confirm"
            onClick={backRedirect}
            text
          />
          <Button
            customClass="mt-3 mx-3"
            label="Cancel"
            onClick={cancelClick}
            primary
            text
          />
        </div>
      </>
    )
  }

  const handleCSVExport = () => {
    const csvHeader = ["PARENT_FIRST_NAME", "PARENT_LAST_NAME", "PARENT_EMAIL", "PARENT_PHONE_NUMBER", "CHILD_FIRST_NAME", "ADDRESS_LINE_1", "ADDRESS_LINE_2", "CITY", "STATE_CODE", "ZIP_CODE"];
    var csvTempData: Array<any> = [csvHeader];

    let csvDataString = "";
    csvTempData?.map((val, i) => {
      if (i === csvTempData?.length - 1) {
        csvDataString += val.toString()
      } else {
        csvDataString += val.toString() + "\n";
      }
    });
    const fileName = `kiddo_bulk_upload_template.csv`;
    const downloadType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const base64data = `data:${downloadType};base64,${btoa(csvDataString)}`;
    const downloadLink = document.createElement("a");

    downloadLink.href = base64data;
    downloadLink.download = fileName;
    downloadLink.click();

    return fileName;
  }
  
  return (
    <>
      {isBack && <CustomModal show={true} BodyContent={ConfirmBox} />}
      <div className="patient-add-block">
        <div className="container">
          <div className="cards-wrap">
            <div className="card-body">
              <div className="header position-relative">
                <button type="button" onClick={backButtonClick} className="btn back-btn">
                  <SVG width="15" height="25" src="Assets/Images/Icons/carot-left.svg" />
                </button>
                <div className="logo mb-4 text-center">
                  <SVG
                    className="header-logo"
                    src="Assets/Images/Logos/kiddo.svg"
                    width="108"
                    height="32"
                  />
                </div>
                <h1 className="title-medium text-center mb-4">Add Patient</h1>
                {!isFileSelected ? <button type="button" className="btn btn-success csv-template-button" onClick={handleCSVExport}>Download CSV template</button> : <div>{" "}</div>}
              </div>
              <div className="card-inner">
                <div className="upper-block two-col-view">
                  <div className="tab-section-section add-patient-import mb-5">
                    <Tab.Container id="left-tabs-example" defaultActiveKey="csv">
                      <Row>
                        <Col className="tabs-left-col pe-0">
                          <Nav variant="pills" className="flex-column left-col-inner">
                            <Nav.Item>
                              <Nav.Link eventKey="csv">{" "} Import CSV files</Nav.Link>
                            </Nav.Item>

                            {/* <Nav.Item>
                              <Nav.Link eventKey="ehr" className="">
                                Import from EHR
                              </Nav.Link>
                            </Nav.Item>
                            
                            <Nav.Item>
                              <Nav.Link eventKey="manual" className="">
                                Add One
                              </Nav.Link>
                            </Nav.Item> */}
                          </Nav>
                        </Col>
                        <Col className="content-cols">
                          <Tab.Content>
                            <Tab.Pane eventKey="csv">
                              <AddPatientCSV importComplete={importComplete} setIsFileSelected={setIsFileSelected} />
                            </Tab.Pane>

                            {/* <Tab.Pane eventKey="ehr">
                              Add Patient From EHR 
                            </Tab.Pane> */}

                            {/* <Tab.Pane eventKey="manual">
                              <PatientInfoForm onAddPatient={() => {}} onCancelClick={()=>{}} submitBtnName="Submit" />
                            </Tab.Pane> */}
                          </Tab.Content>
                        </Col>
                      </Row>
                    </Tab.Container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default AddPatientLeads;
